import { ReactNode } from 'react';
import styles from './PhotoText.module.css';

type PhotoTextProp = {
  img: string;
  alt: string;
  children: ReactNode;
};
const PhotoText = (props: PhotoTextProp) => {
  return (
    <div className={styles.container}>
      <img className={styles.photo} src={props.img} loading="lazy" alt={props.alt} />
      <p className={styles.paragraph}>{props.children}</p>
    </div>
  );
};

export default PhotoText;
